<template>
  <section>
    <div class="title is-5 has-text-centered">
      Consolidado
      <hr class="dropdown-divider" aria-role="menuitem" />
    </div>

    <b-table :data="data" striped hoverable>
      <b-table-column
          field="area"
          label="Área Académica"
          width="14%"
          v-slot="props"
      >
        {{ props.row.area }}
      </b-table-column>

      <b-table-column
          field="hours_committed_weekly"
          label="Hrs/Sem Comp."
          width="9%"
          v-slot="props"
      >
        {{ props.row.hours_committed_weekly }}
      </b-table-column>

      <b-table-column
          field="hours_committed_yearly"
          label="Hrs/Año Comp."
          width="9%"
          v-slot="props"
      >
        {{ props.row.hours_committed_yearly }}
      </b-table-column>



      <b-table-column
          field="hours_completed_weekly"
          label="Hrs/Sem Real."
          width="9%"
          v-slot="props"
      >
        {{ props.row.hours_completed_weekly }}
      </b-table-column>

      <b-table-column
          field="hours_completed_yearly"
          label="Hrs/Año Real."
          width="9%"
          v-slot="props"
      >
        {{ props.row.hours_completed_yearly }}
      </b-table-column>


      <b-table-column
          field="committee_score"
          label="Nota"
          width="8%"
          v-slot="props"
      >
        <span v-if="!props.row.has_activities">---</span>
        <span v-else-if="props.row.committee_score === null">Sin calificación</span>
        <span v-else>{{ props.row.committee_score.toFixed(2) }}</span>
      </b-table-column>

      <b-table-column
          field="weight_percentage"
          label="Pond."
          width="8%"
          v-slot="props"
      >
        <span v-if="!props.row.has_activities">---</span>
        <span v-else-if="props.row.weight_percentage === null || props.row.weight_percentage === 0">Sin asignar</span>
        <span v-else>{{ props.row.weight_percentage.toFixed(1) }}%</span>
      </b-table-column>

      <b-table-column
          field="weighted_score"
          label="Nota Pond."
          width="8%"
          v-slot="props"
      >
        <span v-if="!props.row.has_activities">---</span>
        <span v-else-if="props.row.committee_score === null || props.row.weight_percentage === null || props.row.weight_percentage === 0">---</span>
        <span v-else>{{ (props.row.committee_score * props.row.weight_percentage / 100).toFixed(2) }}</span>
      </b-table-column>

      <b-table-column
          field="observation"
          label="Observaciones"
          width="26%"
          v-slot="props"
      >
        <span v-if="!props.row.has_activities">---</span>
        <span v-else-if="!props.row.observations || props.row.observations.length === 0" class="has-text-grey">Sin observaciones</span>
        <span v-else>
          <b-tooltip 
            v-if="props.row.observations.length > 50"
            :label="props.row.observations" 
            type="is-dark" 
            multilined
            position="is-left"
          >
            <span class="is-size-7">{{ props.row.observations.substring(0, 50) }}...</span>
          </b-tooltip>
          <span v-else class="is-size-7">{{ props.row.observations }}</span>
        </span>
      </b-table-column>
    </b-table>

    <div>
      <table class="table is-fullwidth">
        <thead>
        <tr>
          <th style="width: 14%"></th>
          <th style="width: 9%">Semanales</th>
          <th style="width: 9%">Anuales</th>
          <th style="width: 9%">Semanales</th>
          <th style="width: 9%">Anuales</th>
          <th style="width: 8%"></th>
          <th style="width: 8%"></th>
          <th style="width: 8%"></th>
          <th style="width: 26%"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style="width: 14%">Hrs. Cronológicas Prom. Anual</td>
          <td style="width: 9%">{{ hours_weekly }}</td>
          <td style="width: 9%">{{ hours_yearly }}</td>
          <td style="width: 9%">{{ hours_completed_weekly }}</td>
          <td style="width: 9%">{{ hours_completed_yearly }}</td>
          <td style="width: 8%"></td>
          <td style="width: 8%"></td>
          <td style="width: 8%"></td>
          <td style="width: 26%"></td>
        </tr>

        <tr>
          <td style="width: 14%">Hrs. Sem. Equiv. Totales</td>
          <td style="width: 9%">{{ hours_eq }}</td>
          <td style="width: 9%"></td>
          <td style="width: 9%">{{ hours_completed_eq }}</td>
          <td style="width: 9%"></td>
          <td style="width: 8%"></td>
          <td style="width: 8%"></td>
          <td style="width: 8%"></td>
          <td style="width: 26%"></td>
        </tr>

        <tr>
          <td style="width: 14%"><b>Nota Final Comisión</b></td>
          <td style="width: 9%"></td>
          <td style="width: 9%"></td>
          <td style="width: 9%"></td>
          <td style="width: 9%"></td>
          <td style="width: 8%"></td>
          <td style="width: 8%"></td>
          <td style="width: 8%"><b>{{ final_weighted_score }}</b></td>
          <td style="width: 26%">
            <b-tag v-if="finalScoreCategory" :type="finalScoreCategory.type" size="is-medium">
              {{ finalScoreCategory.label }}
            </b-tag>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Leyenda de calificaciones -->
    <div v-if="final_committee_score !== '---' && final_committee_score !== 'Sin calificación'" class="mt-4">
      <b-collapse :open="false" aria-id="scoreScaleCollapse">
        <template #trigger="props">
          <a class="is-size-7">
            <b-icon :icon="props.open ? 'menu-up' : 'menu-down'"></b-icon>
            Ver escala de calificación
          </a>
        </template>
        <div class="notification is-light mt-2">
          <div class="columns is-multiline is-size-7">
            <div class="column is-half-tablet is-one-quarter-desktop">
              <b-tag type="is-success">Sobresaliente</b-tag> 3.7 - 4.0
            </div>
            <div class="column is-half-tablet is-one-quarter-desktop">
              <b-tag type="is-info">Bueno</b-tag> 2.8 - 3.69
            </div>
            <div class="column is-half-tablet is-one-quarter-desktop">
              <b-tag type="is-warning">Aceptable</b-tag> 2.0 - 2.79
            </div>
            <div class="column is-half-tablet is-one-quarter-desktop">
              <b-tag type="is-danger">Condicional</b-tag> 1.5 - 1.99
            </div>
            <div class="column is-half-tablet is-one-quarter-desktop">
              <b-tag type="is-dark">Insuficiente</b-tag> 0 - 1.49
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </section>
</template>

<script>
export default {
  name: "AcademicConsolidated",

  props: ["academic_areas", "performances", "areaWeights", "final_note"],

  data() {
    return {
      data: [],
      hours_weekly: 0.0,
      hours_yearly: 0.0,
      hours_eq: 0.0,
      hours_completed_weekly: 0.0,
      hours_completed_yearly: 0.0,
      hours_completed_eq: 0.0,
      final_committee_score: '---',
      final_weighted_score: '---',
    };
  },

  computed: {
    finalScoreCategory() {
      if (this.final_weighted_score === '---' || this.final_weighted_score === 'Sin calificación') {
        return null;
      }
      const score = parseFloat(this.final_weighted_score);
      if (isNaN(score)) return null;
      
      if (score >= 3.7) {
        return { label: 'Sobresaliente', type: 'is-success' };
      } else if (score >= 2.8) {
        return { label: 'Bueno', type: 'is-info' };
      } else if (score >= 2.0) {
        return { label: 'Aceptable', type: 'is-warning' };
      } else if (score >= 1.5) {
        return { label: 'Condicional', type: 'is-danger' };
      } else {
        return { label: 'Insuficiente', type: 'is-dark' };
      }
    }
  },

  created() {
    this.getConsolidated();
    this.calculateConsolidated();
  },

  methods: {
    getConsolidated() {
      this.data = this.academic_areas.map((area) => {
        return {
          academic_area_id: area.id,
          area: area.alt_name,
          hours_committed_weekly: 0.0,
          hours_committed_yearly: 0.0,
          hours_completed_weekly: 0.0,
          hours_completed_yearly: 0.0,
          hours_committed_weekly_1: 0.0,
          hours_committed_yearly_1: 0.0,
          hours_committed_weekly_2: 0.0,
          hours_committed_yearly_2: 0.0,
          hours_completed_weekly_1: 0.0,
          hours_completed_yearly_1: 0.0,
          hours_completed_weekly_2: 0.0,
          hours_completed_yearly_2: 0.0,
          percentage: 0.0,
          percentage_completed: 0.0,
          committee_score: null,
          weight_percentage: 0,
          observations: '',
          has_activities: false,
        };
      });
    },

    calculateConsolidated() {
      this.data.forEach((area) => {
        area.hours_committed_weekly = 0.0;
        area.hours_committed_yearly = 0.0;
        area.hours_completed_weekly = 0.0;
        area.hours_completed_yearly = 0.0;
        area.hours_committed_weekly_1 = 0.0;
        area.hours_committed_yearly_1 = 0.0;
        area.hours_committed_weekly_2 = 0.0;
        area.hours_committed_yearly_2 = 0.0;
        area.hours_completed_weekly_1 = 0.0;
        area.hours_completed_yearly_1 = 0.0;
        area.hours_completed_weekly_2 = 0.0;
        area.hours_completed_yearly_2 = 0.0;
      });

      this.performances.forEach((performance) => {
        let area = this.data.find(
            (area) => area.academic_area_id === performance.academic_area_id
        );
        let area_index = this.data.findIndex(
            (area) => area.academic_area_id === performance.academic_area_id
        );
        if (area) {
          if (performance.is_weekly_hours) {
            area.hours_committed_weekly_1 += parseFloat(
                performance.hours_committed_semester_1
            );
            area.hours_committed_weekly_2 += parseFloat(
                performance.hours_committed_semester_2
            );

            area.hours_completed_weekly_1 += parseFloat(
                performance.hours_completed_semester_1
            );
            area.hours_completed_weekly_2 += parseFloat(
                performance.hours_completed_semester_2
            );
          } else {
            area.hours_committed_yearly_1 += parseFloat(
                performance.hours_committed_semester_1
            );
            area.hours_committed_yearly_2 += parseFloat(
                performance.hours_committed_semester_2
            );

            area.hours_completed_yearly_1 += parseFloat(
                performance.hours_completed_semester_1
            );
            area.hours_completed_yearly_2 += parseFloat(
                performance.hours_completed_semester_2
            );

          }
          this.data[area_index] = area;
        }
      });

      let total = 0.0;
      let total_completed = 0.0;

      this.data.forEach((area) => {
        area.hours_committed_weekly = parseFloat(
            (
                (area.hours_committed_weekly_1 + area.hours_committed_weekly_2) /
                2
            ).toFixed(1)
        );
        area.hours_committed_yearly = parseFloat(
            (
                area.hours_committed_yearly_1 + area.hours_committed_yearly_2
            ).toFixed(1)
        );

        area.hours_completed_weekly = parseFloat(
            (
                (area.hours_completed_weekly_1 + area.hours_completed_weekly_2) /
                2
            ).toFixed(1)
        );
        area.hours_completed_yearly = parseFloat(
            (
                area.hours_completed_yearly_1 + area.hours_completed_yearly_2
            ).toFixed(1)
        );
        total += area.hours_committed_weekly * 36 + area.hours_committed_yearly;
        total_completed += area.hours_completed_weekly * 36 + area.hours_completed_yearly;
      });

      this.hours_weekly = parseFloat(
          this.data
              .reduce((acc, area) => acc + area.hours_committed_weekly, 0.0)
              .toFixed(1)
      );
      this.hours_yearly = parseFloat(
          this.data
              .reduce((acc, area) => acc + area.hours_committed_yearly, 0.0)
              .toFixed(1)
      );

      this.hours_eq = parseFloat(
          ((this.hours_weekly * 36 + this.hours_yearly) / 44).toFixed(1)
      );


      this.hours_completed_weekly = parseFloat(
          this.data
              .reduce((acc, area) => acc + area.hours_completed_weekly, 0.0)
              .toFixed(1)
      );
      this.hours_completed_yearly = parseFloat(
          this.data
              .reduce((acc, area) => acc + area.hours_completed_yearly, 0.0)
              .toFixed(1)
      );

      this.hours_completed_eq = parseFloat(
          ((this.hours_completed_weekly * 36 + this.hours_completed_yearly) / 44).toFixed(1)
      );

      this.data.forEach((area) => {
        if (total === 0) {
          area.percentage = 0;
        } else {
          area.percentage = parseFloat(
              (
                  ((area.hours_committed_weekly * 36 +
                          area.hours_committed_yearly) /
                      total) *
                  100
              ).toFixed(1)
          );
        }

        if (total_completed === 0) {
          area.percentage_completed = 0;
        } else {
          area.percentage_completed = parseFloat(
              (
                  ((area.hours_completed_weekly * 36 +
                          area.hours_completed_yearly) /
                      total_completed) *
                      100
              ).toFixed(1)
          )
        }
      });

      // Calcular nota promedio del comité por área
      this.data.forEach((area) => {
        const areaPerformances = this.performances.filter(
          (p) => p.academic_area_id === area.academic_area_id
        );
        
        area.has_activities = areaPerformances.length > 0;
        
        const scores = areaPerformances
          .map((p) => p.precalification_score)
          .filter((score) => score !== null && score !== undefined);
        
        if (scores.length > 0) {
          area.committee_score = scores.reduce((sum, score) => sum + parseFloat(score), 0) / scores.length;
        } else {
          area.committee_score = null;
        }

        // Obtener ponderación del área desde areaWeights prop
        if (this.areaWeights && this.areaWeights.length > 0) {
          const areaWeight = this.areaWeights.find(w => w.academic_area_id === area.academic_area_id);
          area.weight_percentage = areaWeight ? parseFloat(areaWeight.weight_percentage) : 0;
        } else {
          area.weight_percentage = 0;
        }

        // Obtener observaciones/comentarios de las actividades del área
        const comments = areaPerformances
          .map((p) => p.precalification_comment)
          .filter((comment) => comment !== null && comment !== undefined && comment.trim() !== '');
        
        area.observations = comments.join(' | ');
      });

      // Calcular nota final ponderada (suma de nota × ponderación / 100)
      const hasAnyActivities = this.data.some((area) => area.has_activities);
      
      // Calcular suma de notas ponderadas
      let totalWeightedScore = 0;
      let totalWeightPercentage = 0;
      let hasValidScores = false;

      this.data.forEach((area) => {
        if (area.has_activities && area.committee_score !== null && area.weight_percentage > 0) {
          totalWeightedScore += (area.committee_score * area.weight_percentage / 100);
          totalWeightPercentage += area.weight_percentage;
          hasValidScores = true;
        }
      });
      
      if (!hasAnyActivities) {
        this.final_committee_score = '---';
        this.final_weighted_score = '---';
      } else if (this.final_note !== null && this.final_note !== undefined) {
        // Usar la nota final del backend si está disponible (calculada con ponderaciones)
        this.final_weighted_score = parseFloat(this.final_note).toFixed(2);
        // Mantener también el promedio simple para referencia
        const allScores = this.data
          .map((area) => area.committee_score)
          .filter((score) => score !== null);
        if (allScores.length > 0) {
          this.final_committee_score = (
            allScores.reduce((sum, score) => sum + score, 0) / allScores.length
          ).toFixed(2);
        } else {
          this.final_committee_score = this.final_weighted_score;
        }
      } else if (hasValidScores) {
        // La nota final es la suma de las notas ponderadas
        this.final_weighted_score = totalWeightedScore.toFixed(2);
        // Mantener también el promedio simple para referencia
        const allScores = this.data
          .map((area) => area.committee_score)
          .filter((score) => score !== null);
        this.final_committee_score = (
          allScores.reduce((sum, score) => sum + score, 0) / allScores.length
        ).toFixed(2);
      } else {
        this.final_committee_score = 'Sin calificación';
        this.final_weighted_score = 'Sin calificación';
      }
    },
  },

  watch: {
    academic_areas: {
      handler() {
        this.getConsolidated();
      },
      deep: true,
    },

    performances: {
      handler() {
        this.calculateConsolidated();
      },
      deep: true,
    },

    areaWeights: {
      handler() {
        this.calculateConsolidated();
      },
      deep: true,
    },

    final_note: {
      handler() {
        this.calculateConsolidated();
      },
    },
  },
};
</script>
